import { z } from "zod";
import { localized } from "../../locales";

/**
 * One set of default approvers as a whole: a workspace's, or the organisation's when
 * `workspaceId` is null. A workspace's set may be empty — its invoices then fall to the
 * organisation's — but the organisation's may not, or an invoice could be raised with nobody to
 * approve it.
 */
export const incomingInvoiceDefaultApproversSchema = z
	.object({
		workspaceId: z.uuid().nullable(),
		userIds: z.array(z.string().min(1)),
	})
	.refine((value) => value.workspaceId !== null || value.userIds.length > 0, {
		path: ["userIds"],
		message: localized("incoming_invoices.approvers_required"),
	});

export type IncomingInvoiceDefaultApproversSchema = z.infer<
	typeof incomingInvoiceDefaultApproversSchema
>;
